export const initialState = {
  settlements: [],
  page: {},
  links: {},
  loadingSettlements: false,
  error: {},
  errorAlert: {},
  createSettlement: {
    sponsorSelectionComplete: false,
    addAuthorizationsComplete: false,
    createSettlementResult: "",
    settlementId: {},
    sponsorSlug: {},
    dates: {
      from: "",
      to: ""
    },
    includedClaims: [],
    excludedClaims: [],
    actualStep: 1,
    errorMessage: ''
  },
  settlementSelected: {},
  settlementDetail: [],
  authorizations: []
}

export default {
  ...initialState
}